import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { AutomationReplacementChipsComponent, AutomationVariableMenuComponent } from '../../../../../common/components';
import { GalaxyInfiniteScrollTriggerModule } from '@vendasta/galaxy/infinite-scroll-trigger';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { StandardIds } from '@galaxy/crm/static';
import { CrmTaskCreatePanelComponent } from './crm-task-create-panel.component';
import { CreateCrmActivityMigrationMixin } from '../../create-crm-activity/create-crm-activity-migration.mixin';

@Component({
  selector: 'automata-crm-task-create-panel-v2',
  templateUrl: './crm-task-create-panel.component.html',
  styleUrls: ['./crm-task-create-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    AutomationVariableMenuComponent,
    GalaxyInfiniteScrollTriggerModule,
    GalaxyTooltipModule,
    AutomationReplacementChipsComponent,
  ],
})
export class CrmTaskCreatePanelV2Component
  extends CreateCrmActivityMigrationMixin(CrmTaskCreatePanelComponent)
  implements OnInit
{
  protected migratedKeys: [string, string][] = [
    ['task_name', StandardIds.ActivityName],
    ['task_body', StandardIds.ActivityTaskBody],
    ['task_priority', StandardIds.ActivityTaskPriority],
    ['task_status', StandardIds.ActivityTaskStatus],
    ['task_type', StandardIds.ActivityTaskType],
    ['tags', StandardIds.ActivityTags],
  ];

  protected override setOnInit(data: any): void {
    data.task_days_to_complete = data.days_until_due;
    data.salesperson_id = data.owner_id;
  }

  protected override setOnGetData(data: any): void {
    data.days_until_due = data.days_until_due || data.task_days_to_complete;
    data.owner_id = data.owner_id || data.salesperson_id;
    delete data.task_days_to_complete;
    delete data.salesperson_id;
  }
}
